import React from 'react'
// import VideoModal from '../ModalVideo/VideoModal'
import { Link } from 'react-router-dom'
// import CountUp from 'react-countup'
// import abImg from '../../images/about/about-1/1.jpg'
import abImg2 from '../../images/about/about-1/2.jpg'
import RollingText from '../RollingText/RollingText'

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(0, 0)
  }

  return (
    <section id="about" className={'' + props.hclass}>
      <div className="about-wrap container">
        <div className="about-content">
          <div className="content">
            <h2
              className="scroll-text-animation"
              data-animation="fade_from_right"
            >
              About A to Z Construction
            </h2>
            <p className="fade_bottom">
              With origins that trace back to 1998, A to Z Construction Company
              has emerged as a hallmark of excellence in architecture,
              construction, contracting, and investment across Iraq. Built on
              unwavering principles of integrity, quality, and visionary
              craftsmanship, we are committed to delivering projects that not
              only meet expectations but redefine industry standards.
            </p>
            <p className="fade_bottom">
              At A to Z, we don’t just construct buildings—we craft landmarks
              that endure and inspire. Our philosophy is rooted in a holistic
              approach that seamlessly unites conceptual design, engineering
              supervision, construction execution, and strategic investment.
              This integrated model guarantees that each project is delivered
              with uncompromising precision, unmatched efficiency, and
              exceptional quality, setting the stage for sustainable growth and
              long-term value.
            </p>
            <div className="about-btn ">
              <Link onClick={ClickHandler} to="/about" className="theme-btn">
                <RollingText text={'Learn More About Us'} />
              </Link>
            </div>
          </div>
        </div>
        <div>
          <div className="image">
            {/* <div className="image-1  poort-in-right">
              <img src={abImg} alt="" />
            </div> */}
            <div className="image-2 poort-in-right">
              <img className="img-about" src={abImg2} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
